import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from 'components/AppBar';
import UserArea from 'components/UserArea';
import MainTitle from 'components/MainTitle';

import { MainToolbar_data$key } from '__generated__/MainToolbar_data.graphql';
import ColorModeSwitch from 'components/ColorModeSwitch';

type Props = {
  data: MainToolbar_data$key;
  open: boolean;
  onToggle: () => void;
};

const MainToolbar: FC<Props> = ({ data, open, onToggle }) => {
  const { viewer } = useFragment(
    graphql`
      fragment MainToolbar_data on Query {
        viewer {
          ...UserArea_user
        }
      }
    `,
    data
  );

  return (
    <AppBar position="absolute" open={open}>
      <Toolbar
        sx={{
          pr: '24px', // keep right padding when drawer closed
        }}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={onToggle}
          sx={{
            marginRight: '36px',
            ...(open && { display: 'none' }),
          }}>
          <MenuIcon />
        </IconButton>

        <MainTitle />

        <ColorModeSwitch />

        {viewer && <UserArea user={viewer} />}
      </Toolbar>
    </AppBar>
  );
};

export default MainToolbar;
